import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Expediente } from 'app/models/expedientes/expediente';
import { ExpedienteService } from 'app/services/expediente.service';
import { ConvocatoriaService } from 'app/services/convocatoria.service';
import { AppConfig } from 'app/app.config';
import { AsignacionComponent } from '../asignacion/asignacion.component';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-listado',
  templateUrl: './listado.component.html',
  styleUrls: ['./listado.component.scss']
})
export class ListadoComponent implements OnInit {

  expedientes: Expediente[] = [];
  loading: boolean;
  convocatoria : String;
  idconvocatoria: number;
  tipo: string;
  rol: any;
  bsModalRef?: BsModalRef;
  convocatorias: any;

  constructor(private modalService: NgbModal/*,private modalService: BsModalService*/,private route: ActivatedRoute,private convocatoriaService: ConvocatoriaService, private expedienteService: ExpedienteService,private config: AppConfig,private router: Router) {
    
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.rol = currentUser.rol;

    this.route.params.subscribe(routeParams => {
      this.tipo=routeParams.tipo;
      if(routeParams.idconvocatoria){
        this.idconvocatoria=routeParams.idconvocatoria;

        if(this.idconvocatoria!=0){this.loadAllExpedientes();}
        this.loadAllConvocatorias(routeParams.tipo);

      }
      else
      {
        this.idconvocatoria=0;
        this.expedientes=null;
        this.loadAllConvocatorias(routeParams.tipo);
      }
      

    });
    

  }


  ngOnInit() {

  
    

  }

  private loadAllConvocatorias(tipo) {
    if(tipo == "2") { this.convocatoria='Seguimiento'};
    if(tipo == "1") { this.convocatoria='Implanta'};
    this.loading = true;
    let activa: string;
    
    if (this.rol=="01"){activa="0"}else{activa="1"}

    this.convocatoriaService.getAll(tipo,activa).subscribe(
      data => {
        this.convocatorias = data.convocatorias;
        console.log(data);
        this.loading = false;
      },
      error => {
        if (error.status = 401) {alert('Error'); }
      }
    );
  }


onChangeConvocatoria(event)
{
  this.idconvocatoria=event.target.value;
  if(this.idconvocatoria!=0){ this.loadAllExpedientes()}else{this.expedientes=null};
}


  private loadAllExpedientes() {
    this.loading = true;
    this.expedienteService.getAll(this.idconvocatoria).subscribe(
      data => {
        this.expedientes = data.expedientes;
        console.log(data);
        
        this.loading = false;

      },
      error => {
        if (error.status = 401) {alert('Error'); }
      }
    );
  }



  private delete(idcentro) {
    this.expedienteService.delete(this.idconvocatoria,idcentro).subscribe(
      data => {
        this.loadAllExpedientes();
      },
      error => {
        if (error.status = 401) {alert('Error'); }
      }
    );
  }



  excelValoraciones() {
    window.open(this.config.apiUrl+"/excel/"+this.idconvocatoria);

  }

  openModalWithComponent() {
    let options: NgbModalOptions = {
      size: 'lg',
    };
    const modalRef = this.modalService.open(AsignacionComponent,options);
    modalRef.componentInstance.idconvocatoria = this.idconvocatoria;
    modalRef.componentInstance.convocatoria = this.convocatoria;
    modalRef.result.then(() => { this.loadAllExpedientes(); }, () => { console.log('Backdrop click')})

}

}


// WEBPACK FOOTER //
// /app/src/app/modules/expedientes/listado/listado.component.ts